import { ApiErr, EmptyCallback } from '../api';
import * as TradingView from '../charting_library';
import { hub, hubTFData } from '../hub';
import { IHubInternals, TVContext, tvbar } from './context';
import { dataFeedApi } from '../api/dataFeed'
import { ExchangeType, TickerAssetType, TickerInfo } from '../config/tickers';
export interface TickerTFInfo {
    tf_tv: string;
    l: tvbar[];

}

interface ResolveTickerState {
    error: string;
    data: TradingView.LibrarySymbolInfo;
}
interface resolveSymbolOut extends TradingView.LibrarySymbolInfo, TickerInfo {
}
export class TVDataFeed implements TradingView.IDatafeedChartApi, TradingView.IExternalDatafeed {
    private tvd: TVContext = null;
    private internals: IHubInternals = null;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private static resolvedSymbol = new Map<string, ResolveTickerState>();
    constructor(tvd: TVContext, internals: IHubInternals) {
        this.tvd = tvd;
        this.internals = internals;
    }

    onReady(callback: TradingView.OnReadyCallback) {
        setTimeout(() => callback(this.internals.tvInit), 1);
    }

    getServerTime(callback: TradingView.ServerTimeCallback) {
        setTimeout(() => callback(Date.now() / 1000), 1);
    }

    subscribeBars(symbolInfo: TradingView.LibrarySymbolInfo, resolution: TradingView.ResolutionString, onRealtimeCallback: TradingView.SubscribeBarsCallback, subscriberUID: string, onResetCacheNeededCallback: EmptyCallback) {
        this.tvd.onResetCacheNeededCallback = onResetCacheNeededCallback;
        this.tvd.onRealtimeCallback = onRealtimeCallback;
        //console.info(`datafeed subscribed to ${subscriberUID}, ${symbolInfo.name}`);
    }

    // eslint-disable-next-line @typescript-eslint/no-empty-function,@typescript-eslint/no-unused-vars
    unsubscribeBars(subscriberUID: string) {
        //console.info(`datafeed unsubscribed from ${subscriberUID}`);
    }

    searchSymbols(userInput: string, exchange: string, symbolType: string, onResultReadyCallback: TradingView.SearchSymbolsCallback) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        //if (hub.isSuspended) {
        //    setTimeout(() => {
        //        onResultReadyCallback([]);
        //    });
        //    return;
        //}
        onResultReadyCallback([]);
        //dataFeedApi.post<resolveSymbolOut[]>('searchSymbols', {
        //    input: userInput,
        //    exch: exchange,
        //    asset: symbolType
        //}).catch(x => {
        //    return null as resolveSymbolOut[];
        //}).then(x => {
        //    if (x == null)
        //        return;
        //    const res = [];
        //    res.length = x.length;
        //    for (let i = 0; i < res.length; i++) {
        //        res[i] = {
        //            symbol: x[i].id,
        //            full_name: x[i].name,
        //            description: x[i].desc,
        //            exchange: ExchangeType[x[i].exchId],
        //            type: TickerAssetType[x[i].asset],
        //        };
        //    }
        //    onResultReadyCallback(res);
        //});
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars, sonarjs/cognitive-complexity	
    resolveSymbol(symbolName: string, onResolve: TradingView.ResolveCallback, onError: TradingView.ErrorCallback, extension?: TradingView.SymbolResolveExtension) {
        let ticker = TVDataFeed.resolvedSymbol.get(symbolName);
        if (ticker == null) {
            ticker = {
                data: null,
                error: null
            };
            TVDataFeed.resolvedSymbol.set(symbolName, ticker);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            dataFeedApi.post<resolveSymbolOut>('resolveSymbol', symbolName).catch(x => {
                ticker.error = x;
                TVDataFeed.resolvedSymbol.set(symbolName, null);
                onError(ticker.error);
                return null as resolveSymbolOut;
            }).then(x => {
                if (x == null) 
                    return;
                const nt = {} as TickerInfo;
                Object.assign(nt, x);
                x.ticker = x.id;
                x.description = x.desc;
                x.exchange = ExchangeType[x.exchId];
                x.type = TickerAssetType[x.asset];
                ticker.data = x;
                hub.cacheTickers([nt], true);
                const t = this.internals.data.getTicker(x.id);
                if (t)
                    t.tickerInfo = nt;
                onResolve(ticker.data);
            });
        } else {
            if (!ticker.data && !ticker.error)
                setTimeout(() => this.resolveSymbol(symbolName, onResolve, onError, extension), 100);
            else if (!ticker.error)
                setTimeout(() => onResolve(ticker.data), 0);
            else {
                setTimeout(() => onError(ticker.error), 0);
            }
        }
    }
    //private reqId = 0;
    // eslint-disable-next-line sonarjs/cognitive-complexity
    getBars(symbolInfo: TradingView.LibrarySymbolInfo, resolution: TradingView.ResolutionString, periodParams: TradingView.PeriodParams, onResult: TradingView.HistoryCallback, onError: TradingView.ErrorCallback) {
        const config: GetBarsIn = {
            smpa: hub.hasSmpa(),
            tid: symbolInfo.ticker,
            tf: resolution,
            pars: {
                to: periodParams.to,
                countBack: periodParams.countBack,
                first: periodParams.firstDataRequest
            }
        };
        const ticker = this.internals.data.getTicker(config.tid);
        const barsInfo = ticker.getBars(resolution);
        const pbars = this.tvd.getCachedBars(config.tid, resolution);
        //if (config.pars.first)
        //	barsInfo.bars = [];

        if (!config.pars.first
            && pbars.length > 0) {
            const lb = pbars[0].t / 1000;
            if (lb != config.pars.to)
                config.pars.to = lb;
        }
        if (!config.pars.first
            && config.pars.to <= barsInfo.dataStart) {
            setTimeout(() => onResult([], {
                noData: true,
                nextTime: null
            }), 0);
            return;
        }

        dataFeedApi.post<GetBarsOut>('getBars', config, ticker.tickerInfo.feed).catch(x => {
            //onErrorCallback(x);
            return {
                error: x,
                bars: [],
                meta: {
                    start: 0,
                    startBar: 0
                }
            } as GetBarsOut;
        }).then(x => {
            this.internals.onBarsReceived(config.tid, config.tf);
            if (x == null)
                return;
            let bars: BarData[] = [];

            if (x.bars) {
                //console.log('new bars ' + x.bars.length);
                bars = x.bars.map<BarData>(b => {
                    return {
                        open: b.o,
                        high: b.h,
                        low: b.l,
                        close: b.c,
                        time: b.t,
                        t: b.t,
                        volume: b.v
                    };
                });
            }
            this.internals.data.setReplayMode(symbolInfo.ticker, x.replay);
            barsInfo.startBar = x.meta.startBar;
            barsInfo.dataStart = x.meta.start;
            onResult(bars, x.meta);
        });
    }

    // eslint-disable-next-line @typescript-eslint/no-empty-function,@typescript-eslint/no-unused-vars
    getMarks(symbolInfo: TradingView.LibrarySymbolInfo, from: number, to: number, onDataCallback: TradingView.GetMarksCallback<TradingView.Mark>, resolution: TradingView.ResolutionString) {
    }

    // eslint-disable-next-line @typescript-eslint/no-empty-function,@typescript-eslint/no-unused-vars
    getTimescaleMarks(symbolInfo: TradingView.LibrarySymbolInfo, from: number, to: number, onDataCallback: TradingView.GetMarksCallback<TradingView.TimescaleMark>, resolution: TradingView.ResolutionString) {
    }

    // eslint-disable-next-line @typescript-eslint/no-empty-function,@typescript-eslint/no-unused-vars
    getVolumeProfileResolutionForPeriod(currentResolution: TradingView.ResolutionString, from: number, to: number, symbolInfo: TradingView.LibrarySymbolInfo): TradingView.ResolutionString {
        return null;
    }
}

interface GetBarsIn {
    smpa: boolean,
    tid: string,
    tf: string,
    pars: {
        to: number,
        countBack: number,
        first: boolean
    }
}

interface BarsMeta extends TradingView.HistoryMetadata {
    start: number;
    startBar: number;
}

export interface BarData extends TradingView.Bar {
    t: number;
}
interface GetBarsOut extends ApiErr {
    replay: boolean;
    bars?: tvbar[];
    meta?: BarsMeta;
}
